export const YANDEX_AD_MODES = [
  'none',
  'banner',
  'floor_ad',
  'floor_ad_closed',
  'floor_ad_banner',
  'floor_ad_closed_copy',
] as const;

export const SSP_AD_MODES = [
  'none',
  'ssp_floor_ad',
  'ssp_floor_ad_closed',
] as const;

export const SSP_PARTNER_AD_MODES = ['none', 'ssp_floor_ad_partner'] as const;
